import type { Sites } from '@ps/platform-message-framework/common/Sites';

import type { BetSlipErrorConfig } from '@swf/sports/config/bet-slip-errors';
import {
  betLevelErrorMapping,
  defaultBetLevelErrorConfig
} from '@swf/sports/config/bet-slip-errors';
import type { BetDefinition, PlaceBetResult } from '@swf/sports/types/place-bet';

import { getErrorConfig } from './getErrorConfig';

interface BetLevelError {
  errorMessage: BetSlipErrorConfig;
  betNo: number;
}

export const mapBetLevelErrors = (
  result: PlaceBetResult[] = [],
  betDefinitions: BetDefinition[],
  siteId: Sites
) =>
  result.reduce<Record<string, BetLevelError>>((acc, bet) => {
    let errorCode;

    // Find bet-specific errors
    const failedRunners = bet.runners?.filter(({ failureCode }) => failureCode);
    const failedLegs = bet.legs?.filter(({ failureCode }) => failureCode);
    const { resultCode } = bet;

    // Map response to the opportunities
    const opportunityId = betDefinitions.find(({ betNo }) => betNo === bet.betNo)?.id;

    if (failedRunners?.length) {
      errorCode = failedRunners[0].failureCode;
    } else if (failedLegs?.length) {
      errorCode = failedLegs[0].failureCode;
    } else if (resultCode !== 'SUCCESS' && resultCode !== 'OTHER_FAILURE_IN_REQUEST') {
      errorCode = resultCode;
    }

    if (opportunityId && errorCode) {
      acc[opportunityId] = {
        errorMessage: getErrorConfig({
          config: betLevelErrorMapping[errorCode] ?? defaultBetLevelErrorConfig,
          siteId
        }),
        betNo: bet.betNo
      };
    }

    return acc;
  }, {});
